export default __webpack_public_path__ + "ceb9b5aa3f8b776ee4403c9a3d8615f4.jpeg";